<template>
  <v-layout>
    <d-header fluid>
      <h1 class="title">
        {{ $t("new_user") }}
      </h1>
    </d-header>
    <v-form action="create" />
  </v-layout>
</template>

<script>
import form from "./_form.vue";

export default {
  metaInfo() {
    return {
      title: this.$t("new_user"),
    };
  },
  components: {
    "v-form": form,
  },
};
</script>
